<template>
  <div class="main_view">
    <!--导航栏-->
    <div class="report_head">
        <img src="/static/images/bigdata/maoyan_logo.png"/>
    </div>
    <!--二维码-->
    <div class="service">
      <img src="/static/maozhou_wechat.jpg">
    </div>
    <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; margin-top: 20px;">
    <span style="color: black; font-size: 16px; font-weight: normal; margin-top: 5px;">
              有任何问题都可以反馈且联系到我们
    </span>
    </div>

    <el-form ref="form" :model="form" style="width: 80%; margin-left: 10%; margin-top: 20px; margin-bottom: 20px;">
      <el-form-item>
        <el-input v-model="form.name" placeholder="您的称呼（已加密）"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="form.phone" placeholder="手机号码（已加密）"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input type="textarea" v-model="form.text" placeholder="遇到的问题"></el-input>
      </el-form-item>
      <el-checkbox v-model="checked" label="已阅读并同意《个人信息与隐私保护条款》" disabled></el-checkbox>
      <el-button type="info" @click="onSubmit" style="width: 100%; background-color: #000000; margin-top: 5px;">提交反馈</el-button>
    </el-form>
    <el-dialog title="操作提示"  width="80%" :visible.sync="dialogVisible" :center="true" :show-close="false">
      <span>{{dialogMsg}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import process from "shelljs";

export default {
  name: "Contact",
  components: {
  },
  data() {
    return {
      form: {
        name: '',
        phone:'',
        text:'',
      },
      checked: true,
      dialogMsg: '',
      dialogVisible: false,
    }
  },
  methods: {
    onSubmit() {
      let base = '/api'
      if (process.env.NODE_ENV === "development") {
        base = 'http://api.wushangxianzhi.com'
      }
      let url = '/api/v2/maoapp/contact_vue'
      this.$axios({
        method:'post',
        headers: {
          'content-type': 'application/x-www-form-urlencoded', // 注释1
        },
        url: `${base}${url}`,
        data:this.form,
      }).then((response) =>{          //这里使用了ES6的语法
        // alert(response.data.msg)
        this.dialogMsg = response.data.msg
        this.dialogVisible = true
        console.log(response.data)      //请求成功返回的数据
      }).catch((error) => {
        alert(error)
        console.log(error)      //请求失败返回的数据
      })
    }
  },
  mounted: {
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">

.main_view
  background-color $brand-bgm
  display flex
  flex-direction column
  width 100%
  .report_head
    width 100%
    margin 0 auto
    background-color $white
    height 75px
    box-shadow 0px 1px 8px 0px rgba(0,0,0,0.1)
    display flex
    flex-direction row
    align-items center
    img
      margin 0 auto
      width 185px
      height auto

  .service
    padding-top 10px
    display flex
    width 100%
    max-width 300px
    margin 0 auto
    height auto
    img
      width 100%
      height auto

</style>



// WEBPACK FOOTER //
// src/components/Contact.vue